import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmModalComponent } from '../../../modals/confirm-modal/confirm-modal.component';
import { PromptModalComponent } from '../../../prompt-modal/prompt-modal.component';
import { FirebaseService } from '../../../service/firebase.service';
import { SharedService } from '../../../services/shared.service';
import { TranslationPipe } from '../../../shared/pipes/translation.pipe';

interface lotteryConfig {
  name: string,
  active: boolean,
  data: any
}

@Component({
  selector: 'app-lottery-container',
  templateUrl: './lottery-container.component.html',
  styleUrls: ['./lottery-container.component.scss']
})
export class LotteryContainerComponent implements OnInit {

  constructor(private _firebase: FirebaseService, private _shared: SharedService, private dialog: MatDialog, private translation: TranslationPipe, private snackBar: MatSnackBar) { }
  listLottery: Array<lotteryConfig> = [];
  public lotteryModuleData: any;
  lotteryModuleId: any;
  public selectedLotteryConfig: any = null;
  public selectedLotteryIndex: any;


  public latestUpdateDate: any;


  public dialogRef;

  ngOnInit(): void {

    console.log(this._shared.selectedDevice)
    this._firebase.getModuleFromDevice('lottery', this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name).then((d) => {
     // console.log(d.data);
      this.lotteryModuleId = d.id
      this.lotteryModuleData = d.data
     // console.log(this.lotteryModuleId)
      if (!d.data.listConfig) {
        d.data.listConfig = [];
        d.data.listConfig.push({ name: 'Default', active: true, data: d.data.config })
      }
      this.listLottery = d.data.listConfig;
    })
  }

  createLottery() {


    this.dialogRef = this.dialog.open(PromptModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: { title: this.translation.transform('enterLotteryName') }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      let snack = this.snackBar.open('Création en cours...')
      if (result) {
        let defaultPrizerArray = [{
          color: "#232323",
          currentQuantity: 0,
          descriptif: "Perdu",
          isWinner: false,
          nbr: 0,
          resultText: "Vous avez perdu",
          special: false
        }, {
          color: "#7301fb",
          currentQuantity: 10,
          descriptif: "Lot n°1",
          isWinner: true,
          nbr: 10,
          resultText: "🎉 Vous avez remporté le Lot n°1",
          special: false
        }, {
          color: "#40c200",
          currentQuantity: 10,
          descriptif: "Lot n°2",
          isWinner: true,
          nbr: 10,
          resultText: "🎉 Vous avez remporté le Lot n°2!",
        }]

        let defaultSoundObject = {
          loop: {
            data: { name: null, url: null },
            enable: false
          },
          win: { data: { name: null, url: null }, enable: false },
          lose: { data: { name: null, url: null }, enable: false }
        }



        let config = { Nbr_total_lot: 20, colorBackground: "#FFFFFF", current_Nbr_total_lot: 20, endBackground: { name: null, url: null }, endTime: "17:00", startTime: '08:00', startDate: new Date(), endDate: new Date(), latestGame: new Date(), gameActive: true, gameType: 'wheel', prizeArray: defaultPrizerArray, startText: "Lancer le jeu !", sound: defaultSoundObject }


     

        this._firebase.generateLotteryNewAudioFile().then(d => {

          config.sound = d;
          this.listLottery.push({ name: result, active: false, data: config })
          this._firebase.updateModule(this.lotteryModuleId, { listConfig: this.listLottery }).then(d => {
            snack.dismiss();
          }).catch(err => {
            snack.dismiss();
            snack = this.snackBar.open('Une erreur est survenue', null,{ duration: 5 });
          })
        });
      }






    })

  }

  getLotteryData(lottery, index) {

    //console.log(lottery.data)
    this.selectedLotteryConfig = lottery;
    this.selectedLotteryIndex = index;
  }

  setActiveLottery(lottery, index) {
    this.listLottery.forEach((item) => {
      item.active = false;
    })
    this.listLottery[index].active = true;

    this._firebase.updateModule(this.lotteryModuleId, { listConfig: this.listLottery, config: this.listLottery[index].data })

    this.selectedLotteryConfig = null;
    this.selectedLotteryIndex = null;

   /* this._firebase.updateConfigModule({ listConfig: this.listLottery, config: this.listLottery[index].data, latestUpdate:  }, this.lotteryModuleId).then(d => {
      let tmp = JSON.parse(JSON.stringify(this.lotteryModuleData));


      tmp.latestUpdate = d;

      this.lotteryModuleData = tmp;
    })*/

  }
  removeLottery(lottery, index) {
    if (!lottery.active) {
      let dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '30vw',
        height: '30vh',
        data: { title: this.translation.transform('warningDeleteLottery'), ok: 'OK', cancel: this.translation.transform('cancel') }
      })


      dialogRef.afterClosed().toPromise().then(result => {

        if (result) {
          //console.log(index, lottery)



          this._firebase.deleteLotteryFiles(this.listLottery[index])
          this.listLottery.splice(index, 1);
          this._firebase.updateModule(this.lotteryModuleId, { listConfig: this.listLottery })
        }
      })
    }
    else {
      this.snackBar.open(this.translation.transform("warningDeleteActiveLottery") as string, 'OK', { duration: 5000 })
    }


  }
  renameLottery(lottery, index) {
    this.dialogRef = this.dialog.open(PromptModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: { title: this.translation.transform('enterLotteryName'), inputData: lottery.name }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.listLottery[index].name = result;
        this._firebase.updateModule(this.lotteryModuleId, { listConfig: this.listLottery })
      }

    })
  }


  updateCurrentConfig(e) {
    let data = e.currentConfig;
    let latestUpdate = e.currentLatestUpdate;

    this.listLottery[this.selectedLotteryIndex].data = data;

    if (this.selectedLotteryConfig.active)
    {


      /*this._firebase.updateModule(this.lotteryModuleId, { listConfig: this.listLottery, config: data, latestUpdate: latestUpdate }).then(d => {

      })*/
      this._firebase.updateConfigModule({ listConfig: this.listLottery, config: data, latestUpdate: latestUpdate }, this.lotteryModuleId).then(d => {
        let tmp = JSON.parse(JSON.stringify(this.lotteryModuleData));


        tmp.latestUpdate = d;

        this.lotteryModuleData = tmp;
      })

    }
    else {

      this._firebase.updateConfigModule({ listConfig: this.listLottery, latestUpdate: latestUpdate }, this.lotteryModuleId).then(d => {
        let tmp = JSON.parse(JSON.stringify(this.lotteryModuleData));


        tmp.latestUpdate = d;

        this.lotteryModuleData = tmp;
      })
    //  this._firebase.updateModule(this.lotteryModuleId, { listConfig: this.listLottery, latestUpdate: latestUpdate })
    }


 //   console.log(data, latestUpdate)
  }

}
